import React, { useEffect } from 'react';

import { Outlet } from 'react-router-dom';

import { configs } from '@constants/configs/configs';
import { ALL_USER_ROLES, USER_GROUPS } from '@constants/roles/userRoleTypes';
import NavBarContainer from '../common/NavBarContainer';
import EnrollerAnnouncements from '@components/common/EnrollerAnnouncements';
import { brokerNavLinks } from '../individualPortal/navigation/configs/brokerSideNavConfigs';
import { assisterNavLinks } from '../individualPortal/navigation/configs/assisterSideNavConfigs';
import SideNav from '@components/individualPortal/navigation/SideNavigation';
import { bindActionCreators } from 'redux';
import {
    fetchDelegationData, fetchLeftNavParams, fetchNavBarData,
    initDelegationFilters, resetFilterValues,
    setFilterValue
} from '@actions/delegation/delegationActionCreators';
import { getTickets } from '@actions/individualPortal/ticket/ticketActionCreators';
import { connect } from 'react-redux';
import getRoleGroupByRole from '@utils/dashboard/getRoleGroupbyRole';
import { useBroker } from '../../hooks';
import { CERTIFICATION_TYPES } from '@constants/common/statusTypes';
import { ConditionalRendering } from '@components/common/conditional-rendering';

const BrokerContainer = props => {
    const { endpoints } = configs;
    const {
        actions,
        environment: {
            stateCode,
            user: {
                activeModuleName
            },
            language,
            isState,
            impersonation,
            isMNFullStack,
            ticketEnabled,
            impersonationDetails,
            preventConsumerPreferencePageAccess
        },
        delegation: {
            leftNavParams
        }
    } = props;

    const role = activeModuleName.toUpperCase();
    let roleGroup = getRoleGroupByRole(role);
    if(impersonation) roleGroup = getRoleGroupByRole(impersonationDetails.role);
    const isBrokerOrAssister = [ALL_USER_ROLES.BROKER, ALL_USER_ROLES.ASSISTER].includes(roleGroup);
    const containerWidth = (roleGroup === USER_GROUPS.AGENCY_GROUP || roleGroup === USER_GROUPS.CSR_GROUP) ?
        'grid-col-12' : 'grid-col-9';

    const { isHouseIconVisible } = useBroker();
    useEffect(() => {
        if (isBrokerOrAssister || (impersonation && impersonationDetails.role === ALL_USER_ROLES.BROKER)) {
            actions.fetchLeftNavParams(endpoints.AGENT_LEFT_NAV_PARAMS);
        }
    }, []);

    const LeftNav = () => {
        let navLinksByRole = '';
        const { switchAccUrl, selfDelegationSwitchAccUrl, encryptedBrokerAssisterId } = leftNavParams;

        switch (roleGroup) {
            case ALL_USER_ROLES.BROKER:
                navLinksByRole = brokerNavLinks;
                break;
            case ALL_USER_ROLES.ASSISTER:
                navLinksByRole = assisterNavLinks;
                break;
            default:
                break;

        }

        return (
            ((roleGroup === ALL_USER_ROLES.BROKER || roleGroup === ALL_USER_ROLES.ASSISTER) || (impersonation && impersonationDetails.role ===  ALL_USER_ROLES.BROKER)) &&
            <aside className="usa-layout-docs__sidenav desktop:grid-col-3" id="side-nav">
                { leftNavParams && Object.keys(leftNavParams).length > 0 &&
                <SideNav
                    {...{ stateCode }}
                    navLinks={navLinksByRole}
                    userRole={role}
                    visibilityParams={{ ...leftNavParams, isMNFullStack, ticketEnabled, preventConsumerPreferencePageAccess }}
                    replacements={{ switchAccUrl, encryptedBrokerAssisterId, selfDelegationSwitchAccUrl, lang: language === 'en' ? 'en_US' : 'es_ES' }}
                /> }
            </aside>);
    };
    const isMenuHidden = (isBrokerOrAssister && leftNavParams.brokerCertification?.toUpperCase() !== CERTIFICATION_TYPES.CERTIFIED);

    return (
        // Delegation default as a separate page
        <div id="delegation" className="usa-layout-docs usa-section gi-main-section delegation">
            <div className="grid-container grid-widescreen gi-grid-container">
                <ConditionalRendering isTrue={!isMenuHidden}>
                    <div className="grid-row">
                        <NavBarContainer roleGroup={roleGroup} arrayOfUserRoles={[USER_GROUPS.AGENCY_GROUP, ALL_USER_ROLES.BROKER, ALL_USER_ROLES.ASSISTER]} navBarClass='grid-col-12 broker-top-nav' houseIcon={isHouseIconVisible}/>
                    </div>
                    <div className="grid-row">
                        <div className="grid-col-12">
                            <EnrollerAnnouncements />
                        </div>
                    </div>
                </ConditionalRendering>
                <div className="grid-row grid-gap">
                    <LeftNav/>
                    <div className={`usa-layout-docs__main desktop:${containerWidth}`} id="main-content">
                        <div style={{ margin: '30px' }}>
                            <Outlet/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    environment: state.common.environment,
    delegation: state.delegation
});
const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        fetchDelegationData,
        initDelegationFilters,
        setFilterValue,
        resetFilterValues,
        fetchNavBarData,
        fetchLeftNavParams,
        getTickets
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(BrokerContainer);
